// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addMilliseconds as fn } from "../addMilliseconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addMillisecondsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addMillisecondsWithOptions;
